/**
 * Case à cocher du Module Studio (retour d'Olivier, 18.10 : « Check boxes => FAR TOO SMALL » sur les attestations de « Import a prototype »).
 *
 * Une seule définition de la case : la classe de design system `.ui-checkbox` (`design-system/components.css` : 20 px, 24 px au toucher, couleur d'accent du thème)
 * avec l'anneau de focus du socle (`ui-focus-ring`). `StudioCheckbox` est la LIGNE complète : un libellé qui enveloppe la case (tout le libellé est cliquable),
 * `text-sm` au minimum, au moins 44 px de haut au toucher (`pointer-coarse:min-h-11`), la case alignée sur la première ligne du texte (`items-start` : la ligne
 * de `text-sm` fait 20 px, comme la case). Les cases nues d'un tableau ou d'une liste (libellé porté par `aria-label`) prennent `CHECKBOX_CLASS` directement.
 */
import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/design-system/ds-0/components/cn';

/** Classes de la case elle-même (à poser sur un `<input type="checkbox">` nu : cellule de tableau, ligne de liste…). */
export const CHECKBOX_CLASS = 'ui-checkbox ui-focus-ring';

/** Classes du libellé qui enveloppe la case et son texte. */
export const CHECKBOX_ROW_CLASS = 'flex items-start gap-2 text-sm text-portal-ink pointer-coarse:min-h-11';

export interface StudioCheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'className' | 'children'> {
  /** Le texte du libellé (cliquable) : texte ou éléments en ligne. */
  children: ReactNode;
  /** Classes de plus sur le libellé (largeur, espacement) ; la case garde les siennes. */
  className?: string;
}

export default function StudioCheckbox({ children, className, ...input }: StudioCheckboxProps) {
  return (
    <label className={cn(CHECKBOX_ROW_CLASS, className)}>
      <input {...input} type="checkbox" className={CHECKBOX_CLASS} />
      <span className="min-w-0 flex-1">{children}</span>
    </label>
  );
}
